import React, { Fragment, useCallback, useEffect, useState } from 'react'
import Sidebar from './Sidebar'

// icons start 
import { RiEditLine } from "react-icons/ri";
import { MdClose, MdDeleteForever } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { API } from './constant';
import axios from 'axios';
// icons end


const useDebounce = (callback, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            callback(...args)
        }, delay);
    }
}




const Users = () => {

    const [updateTable, setupdateTable] = useState(false)
    const [addProfile, setaddProfile] = useState(false)

    const handleProfileModalOpen = () => {
        setaddProfile(true)
    }

    const handleProfileModalClose = () => {
        setaddProfile(false)
    }


    // ================user data start ===================
    const [userData, setuserData] = useState([])
    // console.log(userData.role)
    useEffect(() => {
        axios.get(`${API}/login/logged-in-user`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data)
                setuserData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // ================user data end ===================



    //------------ get section start ----------------
    const [get_class_section, setget_class_section] = useState([])
    const [allData, setAllData] = useState([]);
    const [permissions, setPermissions] = useState({});
    // console.log(permissions)
    // console.log(get_section)
    useEffect(() => {
        axios.get(`${API}/create-section`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data);
                const fetchedData = res.data.data;

                // Process the new data model to match the existing structure
                const processedPermissions = fetchedData.reduce((acc, item) => {
                    acc[item.class_name] = item.sections.reduce((sectionsAcc, section) => {
                        sectionsAcc[section] = false; // Initialize all sections as unchecked
                        return sectionsAcc;
                    }, {});
                    return acc;
                }, {});

                setAllData(fetchedData);  // If needed for other purposes
                setPermissions(processedPermissions); // Set the permissions state
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    //------------ get section end ----------------


    const handlePermissionChange = (className, section, isChecked) => {
        setPermissions(prevPermissions => ({
            ...prevPermissions,
            [className]: {
                ...prevPermissions[className],
                [section]: isChecked
            }
        }));
    };




    // get all school location start 
    const [getAllSchoolLocation, setgetAllSchoolLocation] = useState([])
    useEffect(() => {
        axios.get(`${API}/school-location`)
            .then((res) => {
                // console.log(res)
                setgetAllSchoolLocation(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // get all school location end



    // ----------create user start ------------------
    const [userName, setuserName] = useState("")
    const [schoolLocation, setschoolLocation] = useState("")
    // console.log(schoolLocation)
    const [userEmail, setuserEmail] = useState("")
    const [userPassword, setuserPassword] = useState("")
    const [userRole, setuserRole] = useState("")


    const submitUser = async (e) => {
        e.preventDefault()
        const data = {
            name: userName,
            school_location: schoolLocation,
            email: userEmail,
            password: userPassword,
            role: userRole,
            permissions: Object.keys(permissions).map(className => ({
                class_name: className,
                sections: Object.keys(permissions[className]).filter(section => permissions[className][section])
            }))
        }
        await axios.post(`${API}/register`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                toast.success(res.data.message)
                clearFields()
                setaddProfile(false)
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err)
                // alert(err.response.data.message)
                toast.error(err.response.data.message)
            })
    }


    // =============get all users start ===================
    const [getAllUser, setgetAllUser] = useState([])

    useEffect(() => {
        axios.get(`${API}/register`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data)
                setgetAllUser(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })

    }, [updateTable])
    //===================== get all users end =================



    // ===============operation on edit user start ===================
    const [editShowModal, seteditShowModal] = useState(false)
    const [selectedRow, setselectedRow] = useState(null)
    const [checkedPermission, setcheckedPermission] = useState({})

    const handleEditUser = (rowData) => {
        setselectedRow(rowData);
        seteditShowModal(true);

        const userPermissions = rowData.permissions.reduce((acc, curr) => {
            acc[curr.class_name] = curr.sections.reduce((sectionsAcc, section) => {
                sectionsAcc[section] = true;
                return sectionsAcc;
            }, {});
            return acc;
        }, {});
        // console.log(userPermissions)
        setcheckedPermission(userPermissions);
    };



    const handleeditPermissionChange = (className, section, isChecked) => {
        setcheckedPermission((prevPermissions) => ({
            ...prevPermissions,
            [className]: {
                ...prevPermissions[className],
                [section]: isChecked,
            },
        }));

        setselectedRow((prev) => {
            const existingClass = prev.permissions.find((perm) => perm.class_name === className);
            let updatedPermissions;

            if (existingClass) {
                updatedPermissions = prev.permissions.map((perm) =>
                    perm.class_name === className
                        ? {
                            ...perm,
                            sections: isChecked
                                ? [...perm.sections, section]
                                : perm.sections.filter((sec) => sec !== section),
                        }
                        : perm
                );
            } else {
                updatedPermissions = [
                    ...prev.permissions,
                    { class_name: className, sections: [section] }
                ];
            }

            return {
                ...prev,
                permissions: updatedPermissions,
            };
        });
    };


    const handleUpdateUser = async (id) => {
        const updatedUser = {
            ...selectedRow,
            permissions: Object.keys(checkedPermission).map((className) => ({
                class_name: className,
                sections: Object.keys(checkedPermission[className]).filter((section) => checkedPermission[className][section]),
            })),
        };

        // Update the data state with the edited row data
        setgetAllUser((prevData) =>
            prevData.map((item) => (item._id === selectedRow._id ? updatedUser : item))
        );

        // Send the updated data to the server (assuming an API endpoint exists)
        await axios
            .put(`${API}/register/${selectedRow._id}`, updatedUser, {
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            })
            .then((res) => {
                console.log(res.data.message);
                alert(res.data.message)
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err);
            });

        seteditShowModal(false); // Close the modal after updating
    };
    // ===============operation on edit user end ===================



    // =============operation on reset password start ===================
    const [resetPasswordModal, setresetPasswordModal] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [resetUserId, setresetUserId] = useState("")
    const [newPassword, setnewPassword] = useState("")

    const handleResetPasswordModal = async (id) => {
        setresetPasswordModal(true)
        setresetUserId(id)
    }


    const handleResetPassword = async (id) => {
        const data = {
            password: newPassword
        }

        await axios.patch(`${API}/register/reset-password/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                // alert(res.data.message)
                toast.success(res.data.message)
                setresetPasswordModal(false)
                setnewPassword("")
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const clearResetPasswordFields = () => {
        setnewPassword("")
    }
    const handleCloseResetPasswordModal = () => {
        setresetPasswordModal(false)
        clearResetPasswordFields()
    }

    // =============operation on reset password end ===================



    // ==================operatio on delete user start ====================
    const [deleteModal, setdeleteModal] = useState(false)
    const [deleteUserId, setdeleteUserId] = useState("")

    const handleDeleteModal = (id) => {
        setdeleteModal(true)
        setdeleteUserId(id)
    }

    const deleteUser = async (id) => {
        try {
            await axios.delete(`${API}/register/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            })
                .then((res) => {
                    // console.log(res)
                    toast.success(res.data.message)
                    setdeleteModal(false)
                    setdeleteUserId("")
                })
                .catch((err) => {
                    console.log(err)
                })
        } catch (error) {
            console.log(error)
        }
    }
    // ==================operatio on delete user end ====================


    const clearFields = () => {
        setuserName("")
        setschoolLocation("")
        setuserEmail("")
        setuserPassword("")
        setuserRole("")
        setPermissions({})
    }


    // filter data start 
    const [searchName, setsearchName] = useState("")
    const [searchEmail, setsearchEmail] = useState("")
    const [searchLocation, setsearchLocation] = useState("")
    const [filteredUser, setfilteredUser] = useState([])

    const handleFilterUser = useCallback(() => {
        let filtered = getAllUser;

        // filter by name start 
        if (searchName) {
            filtered = filtered.filter((item) =>
                item.name.toLowerCase().includes(searchName.toLowerCase())
            )
        }


        // filter by email start 
        if (searchEmail) {
            filtered = filtered.filter((item) =>
                item.email.toLowerCase().includes(searchEmail.toLowerCase()))
        }


        // filter by location start 
        if (searchLocation) {
            filtered = filtered.filter((item) =>
                item.school_location.toLowerCase().includes(searchLocation.toLowerCase()))
        }

        setfilteredUser(filtered)
    }, [getAllUser, searchName, searchEmail, searchLocation])

    const debouncedFilterUser = useDebounce(handleFilterUser, 1000)

    useEffect(() => {

        debouncedFilterUser();

    }, [debouncedFilterUser])


    // filter data end


    return (
        <div>
            <div>
                <Sidebar>
                    <ToastContainer position="top-right" autoClose={3000} />
                    {userData.role === 'Super Admin' ? (
                        <div>


                            <div className='bg-theme_sky_blue h-[10vh] w-full flex items-center px-[20px] text-theme_white'>
                                <div>
                                    <p>Students</p>
                                </div>
                            </div>


                            {/* page content start  */}

                            <div className='m-[15px] flex w-[100%] items-center justify-around'>
                                <div className='flex gap-3 w-[70%]'>
                                    <div className='w-[20%]'>
                                        <label >Search Name:</label>
                                        <input value={searchName} onChange={(e) => setsearchName(e.target.value)} type="search" className='bg-theme_white px-[10px] py-[5px] w-full rounded-3xl outline-theme_yellow_dark border-theme_sky_blue border-[1px]' />
                                    </div>

                                    <div className='w-[20%]'>
                                        <label >Search Email:</label>
                                        {/* <input type="search" className='bg-theme_white px-[10px] py-[5px] w-full rounded-3xl outline-theme_yellow_dark border-theme_sky_blue border-[1px]' /> */}
                                        <input value={searchEmail} onChange={(e) => setsearchEmail(e.target.value)} type="search" className='bg-theme_white px-[10px] py-[5px] w-full rounded-3xl outline-theme_yellow_dark border-theme_sky_blue border-[1px]' />

                                    </div>

                                    <div className='w-[20%]'>
                                        <label >Search Location:</label>
                                        {/* <input type="search" className='bg-theme_white px-[10px] py-[5px] w-full rounded-3xl outline-theme_yellow_dark border-theme_sky_blue border-[1px]' /> */}
                                        <select className='w-full' value={searchLocation} onChange={(e) => setsearchLocation(e.target.value)}>
                                            <option value="">Select Location:</option>
                                            {
                                                getAllSchoolLocation && getAllSchoolLocation.map((item, index) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <option value={item.name}>{item.name}</option>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>

                                </div>

                                <div className='w-[30%]'>
                                    <button onClick={handleProfileModalOpen} className=' bg-theme_green text-theme_white px-[20px] py-[10px] rounded-lg'>Add Profile</button>
                                </div>

                            </div>

                            <div className='p-[20px]'>
                                {/* table start  */}
                                <table>
                                    <thead>
                                        <th>sno.</th>
                                        <th>Name</th>
                                        <th>Location</th>
                                        <th>Role</th>
                                        <th>Email</th>
                                        <th>Edit</th>
                                        <th>Delete</th>
                                    </thead>
                                    <tbody>
                                        {
                                            filteredUser && filteredUser.map((item, index) => {
                                                return (
                                                    <tr key={index} className='text-center text-center border border-gray-300 hover:bg-gray-100'>
                                                        <td>{index + 1}</td>
                                                        <td>{item.name}</td>
                                                        <td>{item.school_location}</td>
                                                        <td>{item.role}</td>
                                                        <td>{item.email}</td>
                                                        <td className='flex justify-center'> <RiEditLine onClick={() => handleEditUser(item)} /> </td>
                                                        <td > <MdDeleteForever onClick={() => handleDeleteModal(item._id)} /> </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                {/* table end */}

                            </div>
                            {/* page content end */}



                            {/* add user start  */}
                            {
                                addProfile && (
                                    <div className='inset-0  fixed z-50 flex'>
                                        {/* backdrop start */}
                                        <div className='absolute inset-0 bg-black bg-opacity-50' onClick={handleProfileModalClose}>
                                        </div>
                                        {/* backdrop end */}


                                        {/* modal panel start  */}
                                        <div className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light overflow-auto transition-transform duration-300 ease-out `}
                                            style={{ height: 'calc(100% - 10vh)' }}
                                        >

                                            <div className='p-6'>
                                                <div className='flex justify-between items-center mb-4'>
                                                    <h2>
                                                        Add User
                                                    </h2>

                                                    <button
                                                        className='text-gray-600 hover:text-gray-800' onClick={handleProfileModalClose}>
                                                        ✕
                                                    </button>
                                                </div>
                                                {/* <p>Create User -</p> */}

                                                <div>
                                                    <div>
                                                        <form >
                                                            <div className='w-full my-[7px]'>
                                                                <div>
                                                                    <label >Name:</label>
                                                                </div>
                                                                <input value={userName} onChange={(e) => setuserName(e.target.value)} type="text" className='w-[100%]' />
                                                            </div>


                                                            <div className='flex gap-5  w-full justify-between items-center'>

                                                                <div className='w-full my-[10px]'>
                                                                    <div>
                                                                        <label >School Location:</label>
                                                                    </div>
                                                                    <select value={schoolLocation} onChange={(e) => setschoolLocation(e.target.value)} className='w-[100%]' >
                                                                        <option value="">Select Location:</option>
                                                                        {
                                                                            getAllSchoolLocation && getAllSchoolLocation.map((item, index) => {
                                                                                return (
                                                                                    <Fragment key={index}>
                                                                                        <option value={item.name}>{item.name}</option>
                                                                                    </Fragment>
                                                                                )
                                                                            })
                                                                        }
                                                                        {/* <option value="">VASUNDHARA</option>
                                                                <option value="">LUCKNOW</option> */}

                                                                    </select>
                                                                </div>

                                                                <div className='w-full my-[10px]'>
                                                                    <div>
                                                                        <label >User Type:</label>
                                                                    </div>
                                                                    <select value={userRole} onChange={(e) => setuserRole(e.target.value)} className='w-[100%]' >
                                                                        <option value="">Select User Type:</option>
                                                                        <option value="Super Admin">Super Admin</option>
                                                                        <option value="Admin">Admin</option>
                                                                        <option value="User">User</option>

                                                                    </select>
                                                                </div>

                                                            </div>

                                                            <div className='w-full my-[7px]'>
                                                                <div>
                                                                    <label >Email:</label>
                                                                </div>
                                                                <input value={userEmail} onChange={(e) => setuserEmail(e.target.value)} type="email" className='w-[100%]' />
                                                            </div>

                                                            <div className='w-full my-[7px]'>
                                                                <div>
                                                                    <label >Password:</label>
                                                                </div>
                                                                <input value={userPassword} onChange={(e) => setuserPassword(e.target.value)} type="password" className='w-[100%]' />
                                                            </div>

                                                            <div className='overflow-hidden'>
                                                                {allData && Object.keys(permissions).map((className, index) => (
                                                                    <div key={index}>
                                                                        <h3>{className}</h3>
                                                                        <div className='flex items-center justify-start gap-3 px-[10px]'>
                                                                            {Object.keys(permissions[className]).map((section, secIndex) => (
                                                                                <Fragment key={secIndex}>
                                                                                    <div key={secIndex}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={permissions[className][section]}
                                                                                            onChange={(e) => handlePermissionChange(className, section, e.target.checked)}
                                                                                        />
                                                                                        <label htmlFor="">{section}</label>
                                                                                    </div>
                                                                                </Fragment>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>




                                                            <div className='my-[20px] flex gap-4'>
                                                                <button onClick={submitUser} className='bg-theme_yellow_dark_transparent text-white px-[20px] py-[10px] rounded-lg'>Submit</button>
                                                                <button onClick={clearFields} className='bg-theme_border text-theme_black px-[20px] py-[10px] rounded-lg'>Clear</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                    {/* 
                                            <div className='my-[10px]'>
                                                <table className='border border-separate'>
                                                    <thead className=''>
                                                        <th>Sno.</th>
                                                        <th>Months</th>
                                                        <th>Edit</th>
                                                        <th>Delete</th>
                                                    </thead>
                                                    <tbody>
                                                        <tr className='text-center '>
                                                            <td>1</td>
                                                            <td>Months</td>
                                                            <td><RiEditLine size={20} /></td>
                                                            <td><MdDeleteForever size={20} /></td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div> */}
                                                </div>

                                            </div>

                                        </div>
                                        {/* modal panel end */}

                                    </div>
                                )
                            }
                            {/* add user end  */}


                            {/* =========update user start==============  */}
                            {
                                editShowModal && editShowModal ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[500px] bg-theme_border'>
                                                <div className='bg-theme_blue text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Edit User</h1></div>
                                                    <div ><MdClose onClick={() => seteditShowModal(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Name:</label>
                                                            </div>
                                                            <div>
                                                                <input value={selectedRow?.name} onChange={(e) => setselectedRow((prev) => ({ ...prev, name: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Name' />
                                                            </div>

                                                        </div>

                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">School Location:</label>
                                                            </div>
                                                            <div>
                                                                <select value={selectedRow?.school_location} onChange={(e) => setselectedRow((prev) => ({ ...prev, school_location: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                                                    <option value="">Select School Location</option>

                                                                    {
                                                                        getAllSchoolLocation && getAllSchoolLocation.map((item, index) => {
                                                                            return (
                                                                                <Fragment key={index}>
                                                                                    <option value={item.name}>{item.name}</option>
                                                                                </Fragment>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>

                                                        </div>
                                                        <div></div>
                                                    </div>

                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Email:</label>
                                                            </div>
                                                            <div>
                                                                <input value={selectedRow?.email} onChange={(e) => setselectedRow((prev) => ({ ...prev, email: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Email' />
                                                            </div>

                                                        </div>

                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Role:</label>
                                                            </div>
                                                            <div>
                                                                <select value={selectedRow?.role} onChange={(e) => setselectedRow((prev) => ({ ...prev, role: e.target.value }))} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                                                    <option value="">Select User Role</option>
                                                                    <option value="Super Admin">Super Admin</option>
                                                                    <option value="Admin">Admin</option>
                                                                    <option value="User">User</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div></div>
                                                    </div>

                                                    <div className='flex'>

                                                    </div>

                                                    <div className=''>

                                                        <div className='text-[18px] px-[20px] mt-[10px] w-full'>
                                                            <div className='flex justify-between items-center my-[10px]'>
                                                                <h1>
                                                                    Permissions:
                                                                </h1>

                                                            </div>

                                                            <div className='h-[20vh] overflow-hidden overflow-y-scroll bg-white px-[10px]'>
                                                                {allData && Object.keys(permissions).map((className, index) => (
                                                                    <div key={index}>
                                                                        <h3>{className}</h3>
                                                                        <div className='flex items-center justify-start gap-3 px-[10px]'>
                                                                            {Object.keys(permissions[className]).map((section, secIndex) => (
                                                                                <Fragment key={secIndex}>
                                                                                    <div>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={checkedPermission[className]?.[section] || false}
                                                                                            onChange={(e) => handleeditPermissionChange(className, section, e.target.checked)}
                                                                                        />
                                                                                        <label htmlFor="">{section}</label>
                                                                                    </div>
                                                                                </Fragment>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div className='flex justify-center gap-[10px] my-[10px]'>
                                                        <button onClick={() => handleUpdateUser(selectedRow?._id)} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Update</button>
                                                        <button onClick={() => handleResetPasswordModal(selectedRow?._id)} className='bg-green-600 text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Reset Password</button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                ) : null
                            }
                            {/* =========update user end==============  */}



                            {/* =========update user password modal start ============ */}
                            {
                                resetPasswordModal && (
                                    <div className='inset-0 fixed flex justify-center items-center bg-black/70'>
                                        <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                            <div className='bg-theme_sky_blue flex justify-between items-center pb-[20px]'>
                                                <div>
                                                    <h1 className='text-[20px]'>Reset User Password</h1>
                                                </div>
                                                <div>
                                                    <MdClose onClick={() => handleCloseResetPasswordModal()} size={30} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='mt-[20px] '>
                                                <div></div>
                                                <label>New Password:</label>
                                                <div></div>
                                                <input type={showPassword ? "text" : "password"} value={newPassword} onChange={(e) => setnewPassword(e.target.value)} className='w-full px-[10px] py-[5px] rounded-md outline-none text-black' />
                                                <input type="checkbox" checked={showPassword} onChange={() => setShowPassword(!showPassword)} />
                                                <label>Show Password</label>


                                                <div className='flex justify-around mt-[30px]'>
                                                    <button onClick={() => handleResetPassword(resetUserId)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Reset Password</button>
                                                    <button onClick={() => handleCloseResetPasswordModal()} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }


                            {/* =========update user password modal end ============ */}



                            {/* ==========delete modal start==============  */}
                            {
                                deleteModal && (
                                    <div className='inset-0 fixed flex justify-center items-center bg-black/70'>
                                        <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                            <div className='flex justify-between items-center pb-[20px]'>
                                                <div>
                                                    <h1 className='text-[20px]'>Delete User</h1>
                                                </div>
                                                <div>
                                                    <MdClose onClick={() => setdeleteModal(false)} size={30} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='mt-[20px] '>
                                                <p className='w-[95%] text-center'>
                                                    Deleting user might affect your records. Do you still want to delete?
                                                </p>
                                                <div className='flex justify-around mt-[30px]'>
                                                    <button onClick={() => deleteUser(deleteUserId)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                    <button onClick={() => setdeleteModal(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {/* ==========delete modal end==============  */}



                        </div>
                    ) : null
                    }
                </Sidebar>
            </div>
        </div>
    )
}

export default Users